import { render, staticRenderFns } from "./estoqueComprometido.vue?vue&type=template&id=8480a598"
import script from "./estoqueComprometido.ts?vue&type=script&lang=js&external"
export * from "./estoqueComprometido.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8480a598')) {
      api.createRecord('8480a598', component.options)
    } else {
      api.reload('8480a598', component.options)
    }
    module.hot.accept("./estoqueComprometido.vue?vue&type=template&id=8480a598", function () {
      api.rerender('8480a598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/estoqueComprometido.vue"
export default component.exports